import React, {Fragment} from 'react';
import {Icons, Popup, Settings} from 'components';
import {noop, openPopup, useNamedSelector} from 'helpers';
import {set} from 'store/settings';

export function SidebarPreferences() {
  const { group } = useNamedSelector('calendar.settings');
  const { externalCalendars, shareStatus } = useNamedSelector('settings.settings');
  return (
    <Fragment>
      <Icons.Sort Sub={!/^(date|time)$/.test(group) && Icons.Bullet} title="Sort by" onClick={openPopup(SortSettings)} />
      <Icons.Settings title="Settings" onClick={openPopup(DisplaySettings)} />
    </Fragment>
  );
}

function SortSettings() {
  const { group, hasCustomOrder } = useNamedSelector('calendar.sort', { module: 'Today' });
  return (
    <Fragment>
      <b>Sort by</b>
      <Popup.Menu>
        <Popup.Menu.Radio onClick={() => set({ module: 'today', key: 'group', value: 'time' })} value="time" checked={group == 'time'}>Time</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ module: 'today', key: 'group', value: 'goal' })} value="goal" checked={group == 'goal'}>Goal</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ module: 'today', key: 'group', value: 'tags' })} value="tags" checked={group == 'tags'}>Tags</Popup.Menu.Radio>
        <Popup.Menu.Radio onClick={() => set({ module: 'today', key: 'group', value: 'priority' })} value="priority" checked={group == 'priority'}>Priority</Popup.Menu.Radio>
        { hasCustomOrder &&
          <Popup.Menu.Radio onClick={() => set({ module: 'today', key: 'group', value: 'customOrder' })} value="customOrder" checked={group == 'customOrder'}>Custom</Popup.Menu.Radio>
        }
      </Popup.Menu>
    </Fragment>
  );
}

function DisplaySettings() {
  return (
    <Fragment>
      <b>Display Options</b>
      <Popup.Menu onClick={noop}>
        <Settings.PopupShareStatus />
        <Settings.PopupExternalCalendars />
      </Popup.Menu>
    </Fragment>
  );
}
